import { render, staticRenderFns } from "./SKREditor.vue?vue&type=template&id=88231ee4&scoped=true&"
import script from "./SKREditor.vue?vue&type=script&lang=ts&"
export * from "./SKREditor.vue?vue&type=script&lang=ts&"
import style0 from "./SKREditor.vue?vue&type=style&index=0&id=88231ee4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88231ee4",
  null
  
)

export default component.exports